


import React, { useEffect, useState } from "react";
import { Tooltip } from "primereact/tooltip";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import "./ExtensionCreationHeader.css"
import VisibilityIcon from "@mui/icons-material/Visibility";
import ClearIcon from "@mui/icons-material/Clear";
const ImageAttachment = ({ imag, onImageChange }) => {

    const [image, setImage] = useState(null);
    useEffect(() => {
        setImage(imag);
    }, [imag]);

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (file && file.type.startsWith("image/")) {
            setImage({
                file,
                preview: URL.createObjectURL(file),
                size: (file.size / 1024).toFixed(1) + " KB",
            });
            onImageChange({ file, preview: URL.createObjectURL(file) });

        }
    };

    const clearImage = (e) => {
        e.stopPropagation();
        setImage(null);
        document.getElementById("imageInput").value = "";
    };

    return (
        <div className="image-attachment-container" onClick={() => document.getElementById("imageInput").click()}>
            <Tooltip target=".image-upload" content="Attach an image" position="top" />
            {image ? (
                <img src={image.preview} alt="Avatar" className="image-avatar" />
            ) : (
                <AddPhotoAlternateIcon className="icon" />
            )}
            <div className="image-info">{image ? `${(image.file ? image.file.name : "")} ` : "Attach Logo for Extension"}</div>
            {image && (
                <div className="actions">
                    <VisibilityIcon className="icon-action preview-icon" onClick={(e) => { e.stopPropagation(); window.open(image.preview, "_blank"); }} />
                    <ClearIcon className="icon-action clear-icon" onClick={clearImage} />
                </div>
            )}
            <input type="file" accept="image/*" id="imageInput" style={{ display: "none" }} onChange={handleFileChange} required />
        </div>
    );
};

export default ImageAttachment;